import { render, staticRenderFns } from "./ResultPPReport.vue?vue&type=template&id=3d86ab34&"
import script from "./ResultPPReport.vue?vue&type=script&lang=ts&"
export * from "./ResultPPReport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports